import { memo } from "react";

import { observer } from "mobx-react-lite";

import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { LiveWorkspaceWidget } from "../lw-widget";
import { MeetingInfoPanel } from "../navbar-menu/components/meeting-info-panel";

const MeetingTopBar = () => {
  const { meeting } = useMeetingDetailsStore();

  return (
    meeting && (
      <>
        <MeetingInfoPanel />
        <LiveWorkspaceWidget />
      </>
    )
  );
};

export default memo(observer(MeetingTopBar));
